module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("RoleApplication", "Role Applications") ))==null?'':__t)+
'</legend></fieldset><div data-region="container"></div><fieldset class="button-wrap"><button data-click="applications-cancel">'+
((__t=( i18n.tc("RoleApplication", "Cancel") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
